export const RC = 0;
export const DEVELOP = "0";
export const VERSION = `5.0.${DEVELOP}`;
export const FROALA_KEY = "DC2D3E3D2C2C1uB5A2B1A1A5F1A3E1J4A16hZSZGUSXYSMZe1JGZ==";
export const CUSTOM_PARAMS = [
  { 'name': 'Document', 'id': 'dni', 'route': 'basicInformation', 'model': 'user' },
  { 'name': 'Email', 'id': 'email', 'route': 'basicInformation', 'model': 'user' },
  { 'name': 'Name', 'id': 'name', 'route': 'basicInformation', 'model': 'user' },
  { 'name': 'Phone', 'id': 'phone', 'route': 'basicInformation', 'model': 'user' }
];
// ############################################################################
// #         Develop configuration                                            #
// ############################################################################
export const XLS_DEVELOP = "https://rebusxls.com";
export const PAY_URL_DEVELOP = "https://rebus-v5-pay-dev.herokuapp.com";
export const AI_URL_DEVELOP = "https://rebus-ia-v5.herokuapp.com";
export const API_URL_DEVELOP = "https://rebus-api-v1.herokuapp.com";
export const BACKEND_DEVELOP = "https://rebus-v5-dev.herokuapp.com";
export const ETL_DEVELOP = "https://rebus-etl-dev.herokuapp.com";
export const JOBS_DEVELOP = "https://jobs-v5.herokuapp.com";
export const NOTIFICATIONS_DEVELOP = "https://notifications-v5-dev.herokuapp.com";
export const REPORTS_DEVELOP = "https://reports-v5-dev.herokuapp.com";
export const CURRENCY_DEVELOP = ["COP", "USD"];
export const XLS_TEMPLATES_DEVELOP = {
  // tslint:disable-next-line:max-line-length
  "7-user-email":
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "8-user-code":
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  endpoint1:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  upload_calendars:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templateExcel%2Fupload_calendars.xlsx?alt=media&token=894e3136-c630-4c69-9956-ebe6a665fcfc",
  // tslint:disable-next-line:max-line-length
  users:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2Fupload_users_03122018.xlsx?alt=media&token=2cd0c1ab-a104-4dad-9abb-fead35484e67",
  // tslint:disable-next-line:max-line-length
  users_club:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2FplantillaClubes.xlsx?alt=media&token=62cb52ff-5325-420d-8c19-4cbe1e746140",
  // tslint:disable-next-line:max-line-length
  users_payment_club:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/datos_de_club.xlsx?alt=media&token=166f6104-f8b8-412c-8612-3e11edbb01ad"
};
export const LANGUAGES_DEVELOP = [
  { key: "es", value: "Spanish" },
  { key: "en", value: "English" }
];
export const FIREBASE_DEVELOP = {
  apiKey: "AIzaSyCh4g5pP9IOKqgj7GH6WGhucp66oHgrix4",
  authDomain: "rebus-v5-dev.firebaseapp.com",
  databaseURL: "https://rebus-v5-dev.firebaseio.com",
  projectId: "rebus-v5-dev",
  storageBucket: "rebus-v5-dev.appspot.com",
  messagingSenderId: "665220179440",
  appId: "1:665220179440:web:cdd46c29a5413afd"
};
// ############################################################################
// #         Staging configuration                                            #
// ############################################################################
export const XLS_STAGING = "https://rebusxls.com";
export const PAY_URL_STAGING = "https://rebus-v5-pay-st.herokuapp.com";
export const AI_URL_STAGING = "https://rebus-ia-v5-st.herokuapp.com";
export const API_URL_STAGING = "https://rebus-api-v1.herokuapp.com/";
export const BACKEND_STAGING = "https://rebus-v5-st.herokuapp.com";
export const ETL_STAGING = "https://rebus-etl-st.herokuapp.com";
export const JOBS_STAGING = "https://jobs-v5-st.herokuapp.com";
export const NOTIFICATIONS_STAGING = "https://notifications-v5-dev.herokuapp.com";
export const REPORTS_STAGING = "https://reports-v5-st.herokuapp.com";
export const CURRENCY_STAGING = ["COP", "USD"];
export const XLS_TEMPLATES_STAGING = {
  // tslint:disable-next-line:max-line-length
  "7-user-email":
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "8-user-code":
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  endpoint1:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  upload_calendars:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templateExcel%2Fupload_calendars.xlsx?alt=media&token=894e3136-c630-4c69-9956-ebe6a665fcfc",
  // tslint:disable-next-line:max-line-length
  users:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2Fupload_users_03122018.xlsx?alt=media&token=2cd0c1ab-a104-4dad-9abb-fead35484e67",
  // tslint:disable-next-line:max-line-length
  users_club:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2FplantillaClubes.xlsx?alt=media&token=62cb52ff-5325-420d-8c19-4cbe1e746140",
  // tslint:disable-next-line:max-line-length
  users_payment_club:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/datos_de_club.xlsx?alt=media&token=166f6104-f8b8-412c-8612-3e11edbb01ad"
};
export const LANGUAGES_STAGING = [
  { key: "es", value: "Spanish" },
  { key: "en", value: "English" }
];
export const FIREBASE_STAGING = {
  apiKey: "AIzaSyBKrIbMiCzMFx7T-gFA8JSH9f9ynXiUWjg",
  authDomain: "rebus-event-tech-st-v5.firebaseapp.com",
  databaseURL: "https://rebus-event-tech-st-v5.firebaseio.com",
  projectId: "rebus-event-tech-st-v5",
  storageBucket: "rebus-event-tech-st-v5.appspot.com",
  messagingSenderId: "630838970097",
  appId: "1:630838970097:web:a3ed87fe2c5f4a99"
};
// ############################################################################
// #         Production configuration                                         #
// ############################################################################
export const XLS_PRODUCTION = "https://rebusxls.com";
export const PAY_URL_PRODUCTION = "https://payment.rebustech.app";
export const AI_URL_PRODUCTION = "https://ai.rebustech.app";
export const API_URL_PRODUCTION = "https://api.rebustech.app";
export const BACKEND_PRODUCTION = "https://api-v5.rebustech.io";
export const ETL_PRODUCTION = "https://etl.rebustech.app";
export const JOBS_PRODUCTION = "https://jobs-v5.rebustech.io";
export const REPORTS_PRODUCTION = "https://reports-v5-prod.herokuapp.com";
export const NOTIFICATIONS_PRODUCTION = "https://notifications-v5-prod.herokuapp.com";
export const CURRENCY_PRODUCTION = ["COP", "USD"];
export const XLS_TEMPLATES_PRODUCTION = {
  // tslint:disable-next-line:max-line-length
  "7-user-email":
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  "8-user-code":
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  endpoint1:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/master%2FcreateEvent.xlsx?alt=media&token=5110134a-4380-4749-8f43-576cb59ad2b3",
  // tslint:disable-next-line:max-line-length
  upload_calendars:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templateExcel%2Fupload_calendars.xlsx?alt=media&token=894e3136-c630-4c69-9956-ebe6a665fcfc",
  // tslint:disable-next-line:max-line-length
  users:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2Fupload_users_03122018.xlsx?alt=media&token=2cd0c1ab-a104-4dad-9abb-fead35484e67",
  // tslint:disable-next-line:max-line-length
  users_club:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templates%2FplantillaClubes.xlsx?alt=media&token=ee05be9d-ca4a-4b4e-ae7b-69047bd6965b",
  // tslint:disable-next-line:max-line-length
  users_payment_club:
    "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/datos_de_club.xlsx?alt=media&token=166f6104-f8b8-412c-8612-3e11edbb01ad"
};
export const LANGUAGES_PRODUCTION = [
  { key: "es", value: "Spanish" },
  { key: "en", value: "English" }
];
export const FIREBASE_PRODUCTION = {
  apiKey: "AIzaSyD51jDCq7W1gtSM1-sYdY5nv79TNnIiRCw",
  authDomain: "rebus-v5-prod.firebaseapp.com",
  databaseURL: "https://rebus-v5-prod.firebaseio.com",
  projectId: "rebus-v5-prod",
  storageBucket: "rebus-v5-prod.appspot.com",
  messagingSenderId: "214988192143",
  appId: "1:214988192143:web:fbc9dd0d3b611b8e"
};
// -------------------------------------------------------------------------------



// WEBPACK FOOTER //
// ./src/environments/global.ts